import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { globalStyles } from '../../styles/globalStyles';

export function NavigationButtons({ onBack, onNext }) {
  return (
    <View style={globalStyles.navigationContainer}>
      <TouchableOpacity 
        style={[globalStyles.navigationButton, globalStyles.backButton]}
        onPress={onBack}
      >
        <Text style={globalStyles.navigationButtonText}>Back</Text>
      </TouchableOpacity>
      
      <TouchableOpacity 
        style={[globalStyles.navigationButton, globalStyles.nextButton]}
        onPress={onNext}
      >
        <Text style={globalStyles.navigationButtonText}>Next</Text>
      </TouchableOpacity>
    </View>
  );
} 